import type { FaireProductEntity } from "../../entity_types/product";

export const p_7ws9q6r6hk: FaireProductEntity = {
  token: "p_7ws9q6r6hk",
  type: "product",
  name: "Vintage Car Wedding Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/94784663d328a2dc103c1175cf0d5a8eb48507f7fbb3d2db7b696f5c0927a25a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9df334ae64d93ba5758100c744ac8909e9ef79a85bb00af084927925b1e5b1ec.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:24.945Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
